var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-map',{attrs:{"data":_vm.data,"show_goods":false,"text":"添加图片"}})
}
var staticRenderFns = []

export { render, staticRenderFns }